const TRACKS = {
  hub: { webm: "/videos/welcome.webm", fallback: "/videos/welcome.mp4" },
  essence: { webm: "/videos/essence.webm", fallback: "/videos/essence.mp4" },
};

let audio;
let currentKey = "hub";
let playing = false;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(playing));

const pickSrc = (a, key) => (a.canPlayType('audio/webm; codecs="opus"') ? TRACKS[key].webm : TRACKS[key].fallback);

export const getTrack = () => {
  if (!audio) {
    audio = new Audio();
    audio.loop = true;
    audio.preload = "auto";
    audio.src = pickSrc(audio, currentKey);
    audio.addEventListener("play", () => { playing = true; notify(); });
    audio.addEventListener("pause", () => { playing = false; notify(); });
    window.__enAudio = audio;
  }
  return audio;
};

export const setTrack = (key) => {
  if (!TRACKS[key] || key === currentKey) return;
  const a = getTrack();
  const wasPlaying = !a.paused;
  currentKey = key;
  a.src = pickSrc(a, key);
  if (wasPlaying) a.play().catch(() => {});
};

export const playTrack = (from) => {
  const a = getTrack();
  if (typeof from === "number" && Number.isFinite(from)) {
    try { a.currentTime = from; } catch { /* not seekable yet */ }
  }
  a.play().catch(() => {});
};

export const toggleTrack = () => {
  const a = getTrack();
  if (a.paused) {
    sessionStorage.removeItem("en_music_off");
    a.play().catch(() => {});
  } else {
    sessionStorage.setItem("en_music_off", "1");
    a.pause();
  }
};

export const subscribeTrack = (fn) => {
  listeners.add(fn);
  fn(playing);
  return () => listeners.delete(fn);
};
